
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help/about",
      function () {
        return require("private-next-pages/help/about.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/help/about"])
      });
    }
  